import styled from "styled-components"
import { getCssSizeValue, isStringEmpty } from "@/utils/utils"
import Image, { formatImageCMSData } from "@/components/common/Image"
import useGlobals from "@/hooks/useGlobals"
import { BREAKPOINTS } from "@/styles/themeSettings"

const StyledWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${(props) => props.theme.colors.richBlack};
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	padding: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	padding-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: unset;
		padding: ${getCssSizeValue(16)};
		padding-bottom: ${getCssSizeValue(24)};
		gap: ${getCssSizeValue(24)};
	}
`

const StyledImageWrapper = styled.div`
	background: ${({ theme }) => theme.colors.whiteSmoke};
	aspect-ratio: 1;
	width: 100%;
	height: auto;
	display: grid;
	place-items: center;
`

const StyledImage = styled(Image)`
	width: 100%;
	height: 100%;

	&.default {
		translate: 0 -5%;
		height: 55%;
		width: auto;
		aspect-ratio: 1;
	}
`

const ImageAndNameWrapper = styled.div`
	position: relative;
`

const Name = styled.div`
	position: absolute;
	background: ${({ theme }) => theme.colors.richBlue};
	color: ${({ theme }) => theme.colors.whiteSmoke};
	padding: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	width: 100%;
	bottom: 0;
	left: 0;
	z-index: 2;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(8)} ${getCssSizeValue(16)};
	}
`

const Role = styled.div`
	padding: 0 ${getCssSizeValue(8)};
`

export function getImageSource(gender, memberImage, maleDefault, femaleDefault) {
	let result
	if (isStringEmpty(memberImage?.url)) {
		result = {
			image: gender === "male" ? maleDefault : femaleDefault,
			defaultImage: true,
		}
	} else {
		result = {
			image: memberImage,
			defaultImage: false,
		}
	}

	return {
		image: formatImageCMSData(result.image),
		defaultImage: result.defaultImage,
	}
}

export default function TeamMember({ member }) {
	const maleDefaultImage = useGlobals((state) => state.teamMemberMaleDefaultImage)
	const femaleDefaultImage = useGlobals((state) => state.teamMemberFemaleDefaultImage)
	const nameAndSurname = member?.nameAndSurname || ""
	const role = member?.role || ""
	const gender = member?.gender || "male"
	const { image, defaultImage } = getImageSource(gender, member?.image, maleDefaultImage, femaleDefaultImage)

	return (
		<StyledWrapper
			className="col-desktop-4 col-mobile-8"
			// onClick={handleMemberClick}
		>
			<ImageAndNameWrapper>
				<StyledImageWrapper>
					<StyledImage
						src={image.url}
						alt={image.alt}
						sizes={"100vw"}
						focalPoint={image.focalPoint}
						className={defaultImage ? "default" : ""}
					/>
					<Name className="typo-borna typo-borna-104">{nameAndSurname}</Name>
				</StyledImageWrapper>
			</ImageAndNameWrapper>
			<Role className="typo-borna typo-borna-111">{role}</Role>
		</StyledWrapper>
	)
}
